import React, {useState, useCallback} from 'react';
import {MsalService, useRegisteredWebComponent} from '@ey/voltron-core';
import env from './env';
import config from '@ey/voltron-config';
import styled from 'styled-components';
import Fetch from '../components/Common/Fetch/fetch';

const HelixWrapper = ({id, srcUrl, wcName, onErrorCallback, className}) => {
	const wcComponent = useRegisteredWebComponent(wcName);
	const [token, setToken] = useState('');
	const [tokenError, setTokenError] = useState('');

	const url = env.getURL('Helix_Analyzer_Base_Url');

	const getAccessToken = async () => {
		try {
			let app = new MsalService(config.ad);
			let resourceUri = MsalService.getAudience(url, config.ad);
			let request = {
				resourceUri,
				account: app.getAccountByUserNameOrDefaultAccount(),
				scopes: [`${resourceUri}/.default`]
			};
			let result = await app.acquireTokenSilent(request);
			return result.accessToken;
		} catch (error) {
			setTokenError(error);
			if (onErrorCallback) {
				onErrorCallback();
			}
		}
	};

	const fetch = useCallback(
		() =>
			getAccessToken().then((result) => {
				setToken(result);
				return Promise.resolve();
			}),
		[]
	);

	const CustomTag = `${wcName}`;
	return (
		<Fetch fetch={fetch}>
			<StyledWCWrapper wcName={wcName} className={`StyledWCWrapper ${className}`}>
				{wcComponent && token ? (
					<CustomTag viewer-id={id} bearer-token={token} src={srcUrl} />
				) : (
					'Loading Helix Viewer...'
				)}
			</StyledWCWrapper>
		</Fetch>
	);
};

const StyledWCWrapper = styled.section`
	height: 100%;
	width: 100%;
	margin: 0 !important;
	display: block;
	hx-viewer {
		display: block;
		height: 100%;
		width: 100%;
		position: relative;
		.application-container {
			position: relative;
			height: 100%;
			width: 100%;
		}
		.pbi-report-container,
		.hx-viewer-container {
			background: transparent;
			position: static;
			height: 80vh;
			@media only screen and (min-width: 768px) and (max-width: 1280px) {
				height: 70vh;
			}
			iframe {
				padding: 0 var(--px-20) 0 var(--px-20);
				position: absolute;
				height: 100%;
				width: 100%;
				top: 0;
				left: 0;
			}
		}
	}
`;

export default HelixWrapper;
